export default __webpack_public_path__ + "static/media/pdf.412710c2.svg";